/**
 * The shopper's phone, remembered between the homepage finder
 * (custom-product-finder.liquid) and the in-collection device filter
 * (collection-device-filter.liquid): picking a model in either one updates it.
 * Stored as menu-<market>.json handles plus the model's display title, which is
 * also the value of the collection's compability filter.
 *
 * { market, brand, model, label, savedAt } in localStorage 'sh-device'.
 * Storage can be blocked (private mode, Safari ITP); every access is guarded and
 * the pickers simply start empty then.
 */
window.shDevice = window.shDevice || {
  key: 'sh-device',
  get(market) {
    try {
      const device = JSON.parse(localStorage.getItem(this.key));
      if (device && device.brand && device.model && device.label && device.market === market) return device;
    } catch (e) {
      // unreadable or blocked storage: nothing remembered
    }
    return null;
  },
  set(device) {
    try {
      localStorage.setItem(this.key, JSON.stringify({ ...device, savedAt: Date.now() }));
    } catch (e) {
      // blocked storage: the pick still works, it just is not remembered
    }
  },
  clear() {
    try {
      localStorage.removeItem(this.key);
    } catch (e) {
      // blocked storage: nothing to forget
    }
  }
};
